export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_8.0be8079d.png";